<div class="ipm-visual-event-image-viewer">
  <button aria-label="close-dialog" mat-icon-button (click)="close()"><mat-icon svgIcon="icon-times-circle"></mat-icon></button>
  <img alt="visual-event-img" aria-label="image-view" [src]="imageUrl | offlineImage | async" />
</div>
